// extracted by mini-css-extract-plugin
export default {"main":"MainTemplate_main__zy1x8","padTop90":"MainTemplate_padTop90__YQXQK","padBottom0":"MainTemplate_padBottom0__0CbWc"};